import { styled } from "@mui/material/styles";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

export const Header = styled("header")(() => ({
  backgroundColor: "#EDF5FB",
  padding: "6px 12px",
  height: 36,
  borderRadius: "0.5rem",
  marginBottom: "0.5rem",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const Title = styled("span")(() => ({
  color: "#465869",
  font: "700 16px/24px Manrope",
}));

export const Icon = (isGroupExpanded: boolean) =>
  styled(isGroupExpanded ? MdKeyboardArrowUp : MdKeyboardArrowDown)(() => ({
    fontSize: 24,
    color: "#465869",
    cursor: "pointer",
  }));
